import { PERMISSION, SECTION } from './permission.enum';

export const ROUTE_PERMISSIONS = {
  DASHBOARD: [PERMISSION.READ_DASHBOARD],
  BENEFICIARY: [PERMISSION.BENEFICIARY_READ],

  HOSPITAL_CONTRACT_CASE: [
    PERMISSION.HOSPITAL_CONTRACT_CASE_READ,
    PERMISSION.HOSPITAL_CONTRACT_CASE_WRITE,
  ],

  HOSPITAL_BANK_ACCOUNT: [PERMISSION.HOSPITAL_READ, PERMISSION.HOSPITAL_WRITE],

  REGISTER_HOSPITAL: [
    PERMISSION.REGISTER_HOSPITAL_READ,
    PERMISSION.REGISTER_HOSPITAL_WRITE,
  ],

  HOSPITAL: [
    PERMISSION.PATIENT_PRINT_FORM_READ,
    PERMISSION.PATIENT_PRINT_FORM_CLOSE,

    PERMISSION.CONSUMPTION_READ,
    PERMISSION.CONSUMPTION_WRITE,
    PERMISSION.CONSUMPTION_APPROVAL,
    PERMISSION.CONSUMPTION_DELETE,

    PERMISSION.CLAIM_REQUEST_HOS_READ,
    PERMISSION.CLAIM_REQUEST_HOS_WRITE,
    PERMISSION.CLAIM_REQUEST_HOS_APPROVAL,
    PERMISSION.CLAIM_REQUEST_HOS_DELETE,
  ],

  PAYMENT_CLAIM: [
    PERMISSION.CLAIM_REQUEST_NSSF_READ_ALL,
    PERMISSION.CLAIM_REQUEST_NSSF_READ_ASSIGN_ONLY,
    PERMISSION.CLAIM_REQUEST_NSSF_APPROVAL,
    PERMISSION.CLAIM_REQUEST_NSSF_ASSIGN,
    PERMISSION.CLAIM_REQUEST_NSSF_MAKE_PAYMENT,

    PERMISSION.PAYMENT_REQUEST_READ,
    PERMISSION.PAYMENT_REQUEST_WRITE,
    PERMISSION.PAYMENT_REQUEST_APPROVAL,
    PERMISSION.PAYMENT_REQUEST_PRINT,

    PERMISSION.TRANSMITTAL_LETTER_READ,
    PERMISSION.TRANSMITTAL_LETTER_WRITE,
    PERMISSION.TRANSMITTAL_LETTER_APPROVAL,
    PERMISSION.TRANSMITTAL_LETTER_PRINT,
  ],

  HOSPITAL_REQUEST: [
    PERMISSION.HOSPITAL_REQUEST_READ,
    PERMISSION.HOSPITAL_REQUEST_WRITE,
    PERMISSION.HOSPITAL_REQUEST_APPROVAL,
    PERMISSION.HOSPITAL_REQUEST_DELETE,

    PERMISSION.HOSPITAL_READ,
    PERMISSION.HOSPITAL_WRITE,

    PERMISSION.HOSPITAL_CONTRACT_READ,
    PERMISSION.HOSPITAL_CONTRACT_WRITE,
    PERMISSION.HOSPITAL_CONTRACT_APPROVAL,
    PERMISSION.HOSPITAL_CONTRACT_DELETE,

    PERMISSION.HOSPITAL_USER_READ,
    PERMISSION.HOSPITAL_USER_WRITE,

    PERMISSION.HOSPITAL_PENALTY_READ,
    PERMISSION.HOSPITAL_PENALTY_WRITE,
  ],

  PHARMACY: [
    PERMISSION.PHARMACY_REQUEST_READ,
    PERMISSION.PHARMACY_REQUEST_WRITE,
    PERMISSION.PHARMACY_REQUEST_APPROVAL,

    PERMISSION.PHARMACY_READ,
    PERMISSION.PHARMACY_WRITE,

    PERMISSION.PHARMACY_CONTRACT_READ,
    PERMISSION.PHARMACY_CONTRACT_WRITE,
    PERMISSION.PHARMACY_CONTRACT_APPROVAL,

    PERMISSION.PHARMACY_USER_READ,
    PERMISSION.PHARMACY_USER_WRITE,
  ],

  NSSF_USER: [
    PERMISSION.READ_NSSF_USER,
    PERMISSION.ALLOW_CREATE_NSSF_USER,
    PERMISSION.ALLOW_EDIT_NSSF_USER,
    PERMISSION.ALLOW_DISABLE_NSSF_USER,
  ],

  SETTING: [
    SECTION.SETTING,
    PERMISSION.READ_SETTING,
    PERMISSION.ALLOW_CREATE_SETTING,
    PERMISSION.ALLOW_EDIT_SETTING,
    PERMISSION.ALLOW_DISABLE_SETTING,

    PERMISSION.HOSPITAL_CONTRACT_CASE_READ,
    PERMISSION.HOSPITAL_CONTRACT_CASE_WRITE,
  ],

  ALL_REPORT: [
    PERMISSION.READ_REPORT_PATIENT_FORM,
    PERMISSION.READ_REPORT_HF_PAYMENT,
    PERMISSION.READ_REPORT_HOSPITAL,
    PERMISSION.READ_REPORT_CONSUMPTION,
  ],
};

export const EXTENDED_ROUTE_PMS = {
  DASHBOARD: [PERMISSION.READ_DASHBOARD],

  BENEFICIARY: [
    PERMISSION.BENEFICIARY_READ,
    PERMISSION.BENEFICIARY_PRINT_PATIENT_FORM,
    PERMISSION.BENEFICIARY_PRINT_EMERGENCY,
    PERMISSION.BENEFICIARY_LOCAL_ELIGIBLE,
    PERMISSION.BENEFICIARY_WORK_HISTORY,
    PERMISSION.BENEFICIARY_TYPE,
  ],

  BENEFICIARY_ALL_READ: [PERMISSION.BENEFICIARY_ALL_READ],
  BENEFICIARY_WORK_HISTORY: [PERMISSION.BENEFICIARY_WORK_HISTORY],

  REGISTER_HOSPITAL: [
    PERMISSION.REGISTER_HOSPITAL_READ,
    PERMISSION.REGISTER_HOSPITAL_WRITE,
  ],

  HOSPITAL_REQUEST: [
    PERMISSION.HOSPITAL_REQUEST_READ,
    PERMISSION.HOSPITAL_REQUEST_WRITE,
    PERMISSION.HOSPITAL_REQUEST_APPROVAL,
    PERMISSION.HOSPITAL_REQUEST_DELETE,
  ],

  HOSPITAL: [PERMISSION.HOSPITAL_READ, PERMISSION.HOSPITAL_WRITE],

  HOSPITAL_CONTRACT: [
    PERMISSION.HOSPITAL_CONTRACT_READ,
    PERMISSION.HOSPITAL_CONTRACT_WRITE,
    PERMISSION.HOSPITAL_CONTRACT_APPROVAL,
    PERMISSION.HOSPITAL_CONTRACT_DELETE,
  ],

  HOSPITAL_CONTRACT_CASE: [
    PERMISSION.HOSPITAL_CONTRACT_CASE_READ,
    PERMISSION.HOSPITAL_CONTRACT_CASE_WRITE,
  ],

  HOSPITAL_BANK_ACCOUNT: [PERMISSION.HOSPITAL_READ, PERMISSION.HOSPITAL_WRITE],

  HOSPITAL_USER: [
    PERMISSION.HOSPITAL_USER_READ,
    PERMISSION.HOSPITAL_USER_WRITE,
  ],

  HOSPITAL_PENALTY: [
    PERMISSION.HOSPITAL_PENALTY_READ,
    PERMISSION.HOSPITAL_PENALTY_WRITE,
  ],

  PHARMACY_REQUEST: [
    PERMISSION.PHARMACY_REQUEST_READ,
    PERMISSION.PHARMACY_REQUEST_WRITE,
    PERMISSION.PHARMACY_REQUEST_APPROVAL,
  ],

  PHARMACY: [PERMISSION.PHARMACY_READ, PERMISSION.PHARMACY_WRITE],

  CONSUMPTION: [
    PERMISSION.CONSUMPTION_READ,
    PERMISSION.CONSUMPTION_WRITE,
    PERMISSION.CONSUMPTION_APPROVAL,
    PERMISSION.CONSUMPTION_DELETE,
  ],

  PATIENT_PRINT_FORM: [
    PERMISSION.PATIENT_PRINT_FORM_READ,
    PERMISSION.PATIENT_PRINT_FORM_CLOSE,
  ],

  CLAIM_REQUEST_HOS: [
    PERMISSION.CLAIM_REQUEST_HOS_READ,
    PERMISSION.CLAIM_REQUEST_HOS_WRITE,
    PERMISSION.CLAIM_REQUEST_HOS_APPROVAL,
    PERMISSION.CLAIM_REQUEST_HOS_DELETE,
  ],

  CLAIM_REQUEST_NSSF: [
    PERMISSION.CLAIM_REQUEST_NSSF_READ_ALL,
    PERMISSION.CLAIM_REQUEST_NSSF_READ_ASSIGN_ONLY,
    PERMISSION.CLAIM_REQUEST_NSSF_APPROVAL,
    PERMISSION.CLAIM_REQUEST_NSSF_ASSIGN,
    PERMISSION.CLAIM_REQUEST_NSSF_MAKE_PAYMENT,
  ],

  TRANSMITTAL_REQUEST: [
    PERMISSION.TRANSMITTAL_LETTER_READ,
    PERMISSION.TRANSMITTAL_LETTER_WRITE,
    PERMISSION.TRANSMITTAL_LETTER_APPROVAL,
    PERMISSION.TRANSMITTAL_LETTER_PRINT,
  ],

  PAYMENT_REQUEST: [
    PERMISSION.PAYMENT_REQUEST_READ,
    PERMISSION.PAYMENT_REQUEST_WRITE,
    PERMISSION.PAYMENT_REQUEST_APPROVAL,
    PERMISSION.PAYMENT_REQUEST_PRINT,
  ],

  PHARMACY_CONTRACT: [
    PERMISSION.PHARMACY_CONTRACT_READ,
    PERMISSION.PHARMACY_CONTRACT_WRITE,
    PERMISSION.PHARMACY_CONTRACT_APPROVAL,
  ],

  PHARMACY_USER: [
    PERMISSION.PHARMACY_USER_READ,
    PERMISSION.PHARMACY_USER_WRITE,
  ],

  NSSF_USER: [
    PERMISSION.READ_NSSF_USER,
    PERMISSION.ALLOW_CREATE_NSSF_USER,
    PERMISSION.ALLOW_EDIT_NSSF_USER,
    PERMISSION.ALLOW_DISABLE_NSSF_USER,
  ],

  SETTING: [
    PERMISSION.READ_SETTING,
    PERMISSION.ALLOW_CREATE_SETTING,
    PERMISSION.ALLOW_EDIT_SETTING,
    PERMISSION.ALLOW_DISABLE_SETTING,
  ],

  ALL_REPORT: [
    PERMISSION.READ_REPORT_PATIENT_FORM,
    PERMISSION.READ_REPORT_PATIENT_FORM_NSSF,
    PERMISSION.READ_REPORT_CONSUMPTION,
    PERMISSION.READ_REPORT_HF_PAYMENT,
    PERMISSION.READ_REPORT_HOSPITAL,
    PERMISSION.READ_REPORT_BENEFICIARY,
  ],

  READ_REPORT_PATIENT_FORM: [
    PERMISSION.READ_REPORT_PATIENT_FORM,
    PERMISSION.READ_REPORT_PATIENT_FORM_NSSF,
  ],
  REPORT_HF_PAYMENT: [PERMISSION.READ_REPORT_HF_PAYMENT],
  HOSPITAL_REPORT: [PERMISSION.READ_REPORT_HOSPITAL],
  CONSUMPTION_REPORT: [PERMISSION.READ_REPORT_CONSUMPTION],
  READ_REPORT_BENEFICIARY: [PERMISSION.READ_REPORT_BENEFICIARY],

  HOSPITAL_SERVICE: [
    PERMISSION.HOSPITAL_SERVICE_READ,
    PERMISSION.HOSPITAL_SERVICE_WRITE,
  ],
};

export const ROUTE_PMS_JSON = [
  {
    name: SECTION.DASHBOARD,
    key: 'DASHBOARD',
    icon: 'dashboard',
    children: [
      {
        name: SECTION.DASHBOARD_WORK,
        path: '/dashboard',
        pms_keys: [PERMISSION.READ_DASHBOARD],
      },
    ],
  },
  {
    name: SECTION.BENEFICIARY,
    key: 'BENEFICIARY',
    icon: 'menu_book',
    children: [
      {
        name: SECTION.BENEFICIARY,
        path: '/beneficiary',
        pms_keys: EXTENDED_ROUTE_PMS.BENEFICIARY,
      },
      {
        name: SECTION.BENEFICIARY_ALL_READ,
        path: '/beneficiary-list',
        pms_keys: EXTENDED_ROUTE_PMS.BENEFICIARY_ALL_READ,
      },
    ],
  },
  {
    name: SECTION.HOSPITAL_CON,
    key: 'HOSPITAL',
    icon: 'medication',
    children: [
      {
        name: SECTION.PATIENT_PRINT_FORM,
        path: '/claim-request/patient-form',
        pms_keys: EXTENDED_ROUTE_PMS.PATIENT_PRINT_FORM,
      },
      {
        name: SECTION.HOSPITAL_CON_REQUEST,
        path: '/claim-request/consumption',
        pms_keys: EXTENDED_ROUTE_PMS.CONSUMPTION,
      },
      {
        name: SECTION.HOSPITAL_CON_TRAN_REQUEST_HOS,
        path: '/claim-request/claim-request',
        pms_keys: EXTENDED_ROUTE_PMS.CLAIM_REQUEST_HOS,
      },
    ],
  },
  {
    name: SECTION.PAYMENT_CLAIM,
    key: 'PAYMENT_CLAIM',
    icon: 'medication',
    children: [
      {
        name: SECTION.HOSPITAL_CON_TRAN_REQUEST_NSSF,
        path: '/payment-claim/claim-request',
        pms_keys: EXTENDED_ROUTE_PMS.CLAIM_REQUEST_NSSF,
      },
      {
        name: SECTION.HOS_CON_INTERPRETETION,
        path: '/payment-claim/request-note',
        pms_keys: EXTENDED_ROUTE_PMS.PAYMENT_REQUEST,
      },
      {
        name: SECTION.HOS_TRANSMITTAL_REQUEST,
        path: '/payment-claim/transmittal-letter',
        pms_keys: EXTENDED_ROUTE_PMS.TRANSMITTAL_REQUEST,
      },
    ],
  },
  {
    name: SECTION.HOSPITAL,
    key: 'HOSPITAL_REQUEST',
    icon: 'local_hospital',
    children: [
      {
        name: SECTION.HOSPITAL_REQUEST,
        path: '/hospital/hospital-request',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_REQUEST,
      },
      {
        name: SECTION.HOSPITAL_RESULT,
        path: '/hospital/hospital-result',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL,
      },
      {
        name: SECTION.HOSPITAL_CONTRACT,
        path: '/hospital/hospital-contract',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_CONTRACT,
      },
      {
        name: SECTION.HOSPITAL_USER,
        path: '/hospital/hospital-manager',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_USER,
      },
      {
        name: SECTION.HOSPITAL_PENALTY,
        path: '/hospital/hospital-result',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_PENALTY,
      },
    ],
  },
  {
    name: SECTION.PHARMACY,
    key: 'PHARMACY',
    icon: 'medication',
    children: [
      {
        name: SECTION.PHARMACY_REQUEST,
        path: '/pharmacy/pharmacy-request',
        pms_keys: EXTENDED_ROUTE_PMS.PHARMACY_REQUEST,
      },
      {
        name: SECTION.PHARMACY_RESULT,
        path: '/pharmacy/pharmacies',
        pms_keys: EXTENDED_ROUTE_PMS.PHARMACY,
      },
      {
        name: SECTION.PHARMACY_CONTRACT,
        path: '/pharmacy/pharmacy-contract',
        pms_keys: EXTENDED_ROUTE_PMS.PHARMACY_CONTRACT,
      },
      {
        name: SECTION.PHARMACY_USER,
        path: '/pharmacy/pharmacy-user',
        pms_keys: EXTENDED_ROUTE_PMS.PHARMACY_USER,
      },
    ],
  },

  {
    name: SECTION.NSSF_USER,
    key: 'NSSF_USER',
    icon: 'manage_accounts',
    children: [
      {
        name: SECTION.NSSF_USER,
        path: '/user-account',
        pms_keys: EXTENDED_ROUTE_PMS.NSSF_USER,
      },
    ],
  },
  {
    name: SECTION.SETTING,
    key: 'SETTING',
    icon: 'settings',
    children: [
      {
        name: SECTION.SETTING,
        path: '/setting',
        pms_keys: EXTENDED_ROUTE_PMS.SETTING,
      },
      {
        name: SECTION.HOSPITAL_FACILITY_CASEASE,
        path: '/setting/contract-casebase-type',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_CONTRACT_CASE,
      },
      {
        name: SECTION.HOSPITAL_SERVICE,
        path: '/setting/hospital-service',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_SERVICE,
      },
    ],
  },
  {
    name: SECTION.ALL_REPORT,
    key: 'ALL_REPORT',
    icon: 'report',
    children: [
      {
        name: SECTION.PATIENT_FORM,
        path: '/report/print-patient',
        pms_keys: EXTENDED_ROUTE_PMS.READ_REPORT_PATIENT_FORM,
      },
      {
        name: SECTION.HF_CONSUMPTION,
        path: '/report/consumption',
        pms_keys: EXTENDED_ROUTE_PMS.CONSUMPTION_REPORT,
      },
      {
        name: SECTION.BEN_TYPE,
        path: '/report/ben-type',
        pms_keys: EXTENDED_ROUTE_PMS.READ_REPORT_BENEFICIARY,
      },
      {
        name: SECTION.REPORT_HF_PAYMENT,
        path: '/report/payment',
        pms_keys: EXTENDED_ROUTE_PMS.REPORT_HF_PAYMENT,
      },
      {
        name: SECTION.HOSPITAL_REPORT,
        path: '/report/hospital',
        pms_keys: EXTENDED_ROUTE_PMS.HOSPITAL_REPORT,
      },
    ],
  },
];
